<template>
  <div>
    <el-dialog
      ref="viewDIalog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h800_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDIalog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="订单类型">
                    <el-radio-group v-model="dialogViewForm.type">
                      <el-radio
                        :label="1"
                        disabled
                      >
                        委托制作
                      </el-radio>
                      <el-radio
                        :label="2"
                        disabled
                      >
                        购买
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="供应商">
                    <el-input
                      v-model="dialogViewForm.supplierName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单日期">
                    <el-date-picker
                      v-model="dialogViewForm.orderDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单总金额">
                    <el-input
                      v-model="dialogViewForm.orderAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预计制作完成日期">
                    <el-date-picker
                      v-model="dialogViewForm.estimatedCompleteDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="实际制作完成日期">
                    <el-date-picker
                      v-model="dialogViewForm.completeDateValue"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="经办人">
                    <el-input
                      v-model="dialogViewForm.manager"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="物料制作费用">
                    <el-input
                      v-model="dialogViewForm.makeAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="其他费用">
                    <el-input
                      v-model="dialogViewForm.otherAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="其他费用说明">
                    <el-input
                      v-model="dialogViewForm.otherReason"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              物料信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialsData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      label="需求&发货明细"
                      type="expand"
                      width="120"
                    >
                      <template slot-scope="scope">
                        <el-table
                          :data="scope.row.orderSendDetailList"
                          style="width: 100%"
                          :header-cell-style="{background:'#00d9ff'}"
                          border
                        >
                          <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                            align="center"
                          />
                          <el-table-column
                            prop="cityName"
                            label="市场"
                            show-overflow-tooltip
                            width="100"
                            header-align="center"
                          />
                          <el-table-column
                            prop="schemeContent"
                            label="需求来源"
                            width="200"
                            show-overflow-tooltip
                            header-align="center"
                          />
                          <el-table-column
                            prop="demandSide"
                            label="需求方"
                            width="100"
                            show-overflow-tooltip
                            header-align="center"
                          />
                          <el-table-column
                            prop="materialsName"
                            label="制作物料"
                            show-overflow-tooltip
                            width="150"
                            header-align="center"
                          />
                          <el-table-column
                            prop="makeNumber"
                            label="数量"
                            width="80"
                            align="center"
                          />
                          <el-table-column
                            prop="productionCompleteValue"
                            label="制作完成"
                            width="80"
                            align="center"
                          />
                          <el-table-column
                            prop="completeDateValue"
                            label="制作完成日期"
                            width="110"
                            align="center"
                          />
                          <el-table-column
                            prop="isShipmentValue"
                            label="已发货"
                            width="70"
                            align="center"
                          />
                          <el-table-column
                            prop="shipmentDateValue"
                            label="发货日期"
                            width="100"
                            align="center"
                          />
                          <el-table-column
                            prop="shipmentContent"
                            label="发货信息内容"
                            show-overflow-tooltip
                            width="200"
                            header-align="center"
                          />
                          <el-table-column
                            prop="transferMethodValue"
                            label="运输方式"
                            width="80"
                            align="center"
                          />
                          <el-table-column
                            prop="isFixedAssetValue"
                            label="固定资产"
                            width="80"
                            align="center"
                          />
                          <el-table-column
                            prop="receiver"
                            label="收货人"
                            width="80"
                            align="center"
                          />
                          <el-table-column
                            prop="receivePhone"
                            label="联系电话"
                            width="120"
                            header-align="center"
                          />
                          <el-table-column
                            prop="receiveAddress"
                            label="收货地址"
                            show-overflow-tooltip
                            width="200"
                            header-align="center"
                          />
                          <el-table-column
                            prop="schemeNo"
                            label="方案编号"
                            width="120"
                            show-overflow-tooltip
                            header-align="center"
                          />
                          <el-table-column
                            prop="schemeName"
                            label="方案名称"
                            width="120"
                            show-overflow-tooltip
                            header-align="center"
                          />
                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="materialsName"
                      show-overflow-tooltip
                      label="物料名称"
                    />
                    <el-table-column
                      label="规格"
                      prop="materialsSpecification"
                      width="100"
                    />
                    <el-table-column
                      label="单位"
                      prop="materialsUnit"
                      width="100"
                    />
                    <el-table-column
                      label="数量"
                      prop="makeNumber"
                      width="100"
                    />
                    <el-table-column
                      label="制作单价(元)"
                      prop="makePrice"
                      width="100"
                    />
                    <el-table-column
                      label="金额"
                      prop="makeAmount"
                      width="100"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              付款&发票信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="已支付金额">
                    <el-input
                      v-model="dialogViewForm.paidAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="付款方式">
                    <el-input
                      v-model="dialogViewForm.paidMethod"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="已收发票金额">
                    <el-input
                      v-model="dialogViewForm.invoiceAmount"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="发票编号">
                    <el-input
                      v-model="dialogViewForm.invoiceNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              照片信息
            </h3>
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建人">
                    <el-input
                      v-model="dialogViewForm.creator"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间">
                    <el-input
                      v-model="dialogViewForm.createTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提交人">
                    <el-input
                      v-model="dialogViewForm.submitter"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提交时间">
                    <el-input
                      v-model="dialogViewForm.submitTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="复核人">
                    <el-input
                      v-model="dialogViewForm.checker"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="复核时间">
                    <el-input
                      v-model="dialogViewForm.checkTimeValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="订单状态">
                    <el-input
                      v-model="dialogViewForm.statusValue"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 数据请求
import { findAttachmentInfoByConditionApi } from '@/api/common'
import { initCommissionedOrderApi } from '@/api/materialsCommissionedOrder'

export default {
  components: { showPreview },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {},
      // 委托制作物料明细
      materialsData: [],
      picList: [],
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.picList = []
        this.baseUrl = process.env.VUE_APP_BASE_API

        this.materialsData = []
        this.dialogViewForm = {}
        this.initData()

        this.$nextTick(() => {
          this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initCommissionedOrderApi({ id: this.dataId, operate: 'view' }).then(response => {
        const { data } = response
        this.dialogViewForm = data.materialsCommissionedOrder
        this.materialsData = data.orderDetailList
        findAttachmentInfoByConditionApi({ sourceType: 18, sourceId: data.materialsCommissionedOrder.id }).then(res1 => {
          if (res1.data && res1.data.length > 0) {
            res1.data.forEach(item => {
              let obj = {}
              obj.name = item.attachmentName
              obj.url = this.baseUrl + item.attachmentUrl
              obj.attachmentName = item.attachmentName
              obj.attachmentUrl = item.attachmentUrl
              if (item.attachmentUrl.indexOf('activityDispatchSignInfo') === -1) {
                this.picList.push(obj)
              }
            })
          }
        })
        this.loading = false
      })
    },
    // 初始往来单位下拉数据
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogViewForm.clearValidate()
    }

  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
</style>
